import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/dailyScripture";

export const getDailyScripture = gql`
  query getDailyScripture($scriptureId: Int!) {
    dailyScripture: daily_scripture(id: $scriptureId) {
      ...allDailyScripturesFields
      typeValue: type_value
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/queries/getDailyScripture.js